import React, { Component } from 'react'
import './Hero.css'

import Res from '../values/Resources'

const mobWidth = 991

export default class Hero extends Component {
	constructor(props) {
		super(props)

		this.firstTime = true
		this.lastScroll = 0

		this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
			show: [false, false, false, false]
		}
	}

	componentDidMount() {
		if(this.state.width < mobWidth) {
			this.showOnMount()
		}
		
		window.addEventListener('resize', this.onResize)
        window.addEventListener('scroll', this.onScroll)
	}

	componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
        window.removeEventListener('scroll', this.onScroll)
    }

	onResize = () => {
		let { innerWidth, innerHeight } = window

		let { width } = this.state

		if(innerWidth < mobWidth && width >= mobWidth)
			this.showOnMount()

		this.setState({
			width: innerWidth,
            height: innerHeight,
		})
	}

	onScroll = (event) => {
		let { scrollTop } = event.srcElement.scrollingElement

		if(this.state.width >= mobWidth && this.lastScroll === 0 && scrollTop > 0) {
			this.setState({
				show: [true, false, false, false]
			})

			setTimeout(() => {
				this.setState({ show: [true, true, true, true] })
			}, 800)

			this.lastScroll = scrollTop
		} else if(this.state.width >= mobWidth && scrollTop === 0 && this.lastScroll > 0) {
			this.setState({
				show: [false, false, false, false]
			})

			this.lastScroll = scrollTop
		}
	}

	showOnMount = () => {
		setTimeout(() => {
			this.setState({ show: [true, false, false, false] })
		}, 120)

		setTimeout(() => {
			this.setState({ show: [true, true, false, false] })
		}, 320)

		setTimeout(() => {
			this.setState({ show: [true, true, true, false] })
		}, 520)
	}

	render() {

		let { show } = this.state

		let heroBg = 'heroBg',
			greeting = show[0] ? 'visible' : '',
			name = show[1] ? 'visible' : '',
			description = show[2] ? 'visible' : ''

		heroBg += show[0] ? ' visible' : ''

		return (
			<div className='hero'>
				<div className={heroBg}/>
				<div className='heroContent '>
					<h1 className={greeting}>{Res.strings.hero_greeting}</h1>
				</div>
				<div className='heroContent heroIntro'>
					<h2 className={name}>{Res.strings.hero_intro_title}</h2>
					<p className={description}>{Res.strings.hero_intro_description}</p>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Hero.js